var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.54545,
    height: 26,
    rx: 1.77273,
    fill: "#000000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.09094,
    y: 7.09091,
    width: 3.54545,
    height: 18.9091,
    rx: 1.77273,
    fill: "#000000",
    fillOpacity: 0.43
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.1819,
    y: 17.7273,
    width: 3.54545,
    height: 8.27273,
    rx: 1.77273,
    fill: "#000000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 21.2727,
    y: 3.54547,
    width: 3.54545,
    height: 22.4545,
    rx: 1.77273,
    fill: "#000000",
    fillOpacity: 0.78
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStat2);
export default __webpack_public_path__ + "static/media/ic_stat2.c293f2c821966f55f7f28e343b95946e.svg";
export { ForwardRef as ReactComponent };